import { AuthTypes, AuthAction, AuthSignInInput, User, AuthResetInput } from '../types';

export function signIn(currentUser: User): AuthAction<{ currentUser: User }> {
    return {
        type: AuthTypes.SIGNIN,
        payload: { currentUser },
    };
}

export function requestSignInEmailPassword(props: AuthSignInInput): AuthAction<AuthSignInInput> {
    return {
        type: AuthTypes.REQUEST_SIGNIN_EMAIL_PASSWORD,
        payload: { ...props },
    };
}

export function signOut() {
    return {
        type: AuthTypes.SIGNOUT,
    };
}

export function requestSignOut() {
    return {
        type: AuthTypes.REQUEST_SIGNOUT,
    };
}

export function resetPassword() {
    return {
        type: AuthTypes.RESET_PASSWORD,
    };
}

export function requestResetPassword(props: AuthResetInput): AuthAction<AuthResetInput> {
    return {
        type: AuthTypes.REQUEST_RESET_PASSWORD,
        payload: { ...props },
    };
}

export function resetPasswordError(error: string) {
    return {
        type: AuthTypes.RESET_PASSWORD_ERROR,
        payload: { error },
    };
}

export function clearResetPassword() {
    return {
        type: AuthTypes.CLEAR_RESET_PASSWORD,
    };
}

export function authError(error: string) {
    return {
        type: AuthTypes.AUTH_ERROR,
        payload: { error },
    };
}
